module.exports = __webpack_public_path__ + "img/Compact-FR-Overview.89fe32ef.jpg";